module.exports = __webpack_public_path__ + "img/lilico.38f3ffec.svg";